module.exports = __webpack_public_path__ + "img/5ac_05.0cebb79e.gif";